import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../_App/Redux/hooks";

import {
  findVehicules,
  findZones,
} from "../_App/Redux/Slices/vehicules/vehiculesSlice";
import {
  findEntretienPieces,
  findEntretiens,
} from "../_App/Redux/Slices/entretiens/entretienSlice";
import EntretiensList from "../Components/Entretien/EntretiensList";
import EntretienForm from "../Components/Entretien/EntretienForm";
import { findPiecesDeRechange } from "../_App/Redux/Slices/piecesRechange/piecesRechangeSlice";
import {
  currentSousSociete,
  OnlineUser,
} from "../_App/Redux/Slices/auth/authSlice";
import { findFiles } from "../_App/Redux/Slices/files/filesSlice";

const Entretiens = () => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedEntretien, setSelectedEntretien] = useState(undefined);
  const [load, setLoad] = useState(false);
  const currentSousSte = useAppSelector(currentSousSociete);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term

  useEffect(() => {
    if (currentSousSte) {
      dispatch(findEntretiens(currentSousSte));
      dispatch(findVehicules(currentSousSte));
      dispatch(findPiecesDeRechange(currentSousSte));
      dispatch(findFiles(null));
      dispatch(findZones(null));
    }
    dispatch(findEntretienPieces(null));
  }, [dispatch, load, currentSousSte]);

  return (
    <div>
      <nav className="navbar search-bar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          <form className="search-form">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <i data-feather="search" />
                </div>
              </div>
              <input
                type="text"
                className="form-control"
                id="navbarForm"
                placeholder="Chercher ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
              />
            </div>
          </form>
        </div>
      </nav>
      <nav className="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#">Entretiens</a>
          </li>
        </ol>
      </nav>
      <div className="row content-card">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <i className="mdi mdi-tune-vertical text-primary " /> Liste des
              Entretiens{" "}
              <button
                className="btn btn-primary float-right"
                onClick={() => setShowModal(true)}
              >
                +
              </button>
            </div>
            <EntretiensList
              searchTerm={searchTerm} // Pass search term as a prop
              selectedEntretien={selectedEntretien}
              setSelectedEntretien={setSelectedEntretien}
              setShowModal={setShowModal}
              load={load}
              setLoad={setLoad}
            />
            <EntretienForm
              showModal={showModal}
              setShowModal={setShowModal}
              selectedEntretien={selectedEntretien}
              setSelectedEntretien={setSelectedEntretien}
              load={load}
              setLoad={setLoad}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Entretiens;
